import * as React from 'react';
import { useCallback, useRef } from 'react';

type PointerPosition = [x: number, y: number];

function eventToPosition(evt: React.MouseEvent): PointerPosition {
  return [evt.screenX, evt.screenY];
}

export function useTrackedPointer() {
  const lastPos = useRef<PointerPosition>([-1, -1]);

  const wasPointerMoved = useCallback((evt: React.MouseEvent) => {
    const newPos = eventToPosition(evt);

    if (lastPos.current[0] === newPos[0] && lastPos.current[1] === newPos[1]) {
      return false;
    }

    lastPos.current = newPos;

    return true;
  }, []);

  const pointerUpdate = useCallback((evt: React.MouseEvent) => {
    lastPos.current = eventToPosition(evt);
  }, []);

  return { pointerUpdate, wasPointerMoved };
}
